<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb>
			<el-breadcrumb-item :to="{ path: '/Home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>药品管理</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: 'index' }">中草药</el-breadcrumb-item>
			<el-breadcrumb-item>添加</el-breadcrumb-item>
		</el-breadcrumb>
		<el-card>
			<el-form label-position="left" label-width="80px">
				<el-form-item label="中草药名">
					<el-input placeholder="请输入中草药名称" v-model="article.name" clearable></el-input>
				</el-form-item>
				<el-form-item label="中草药图">
					<el-upload class="avatar-uploader" 
					ref="upload" :limit="2" :action="imgUrl" :show-file-list="false"
						:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
						<img v-if="article.cover" :src="article.cover" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						
					</el-upload>
				</el-form-item>
				<el-form-item label="描述内容">
					<editor :init="init" api-key='ck6c1h9io2rg4s79wg2w9wh8wgj1o1wkcg2flbwps11xaaoh'
						v-model="article.content">
					</editor>
				</el-form-item>
				
				<!-- <el-form-item label="开启评论">
					<el-radio-group v-model="article.is_idea">
						<el-radio :label="0">允许</el-radio>
						<el-radio :label="1">禁止</el-radio>
					</el-radio-group>
				</el-form-item> -->
		
				<!-- <el-form-item label="文章分类" prop="category_id">
					<el-cascader v-model="article.category_id" :props="propMenu" :options="options"
						@change="changeMenu" clearable :placeholder="'设置一级类目可留空'" :show-all-levels="true">
					</el-cascader>
				</el-form-item>
				
				<el-form-item label="发布日期">
					<el-date-picker v-model="article.update_time" type="datetime" placeholder="选择日期时间">
					</el-date-picker>
				</el-form-item> -->
				<el-form-item>
					<el-button type="primary" @click="addArticle()">确认添加</el-button>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>
<script>
	// 引入tinymce主 件
	//import tinymce from './../../static/tinymce/tinymce'
	import {
		add,
		getCategory
	} from "../../api/herbs.js"
	import Editor from '@tinymce/tinymce-vue'
	export default {
		components: {
			'editor': Editor,
		},
		data() {
			return {
				imgUrl: this.$BASE_URL+'/common/upload/index', //主图上传地址
				article: {
					name: '',
					content: '',
					is_idea: 0,
					update_time: '',
					cover:'',
					cover_cdn: '',
					category_id: ''
				},
				comment: 1,
				init: {
					//plugins: ' lists image colorpicker textcolor wordcount contextmenu autoresize',
					plugins: ' lists image wordcount autoresize',
					toolbar: 'bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent  | undo redo | link unlink image  | removeformat ',
					branding: false,
					min_height: 300,
					images_upload_url: '/demo/upimg.php',
					language: 'zh_CN', //注意大小写
				},
				options: [],
				//文章分类参数
				propMenu: {
					label: 'name',
					value: 'id',
					children: 'children',
					checkStrictly: true,
					lazy: true,
					async lazyLoad(node, resolve) {
						console.log('进入分类懒加载')
						if(node.data.id!=undefined){
							let res = await getCategory({
								pid: node.data.id,
							});
							resolve(res.data.list);
						}else{
							console.log('node:', node.data.id);
						}
						
					}
				},
			}
		},
		created() {
			this.getCategory();
		},
		methods: {
			/**
			 * 菜单改变父级
			 */
			changeMenu(e) {
				if (e == null) {
					this.article.category_id = 0;
				} else {
					let arr = JSON.parse(JSON.stringify(e));
					this.article.category_id = arr.pop();
					console.log('当前值：', this.article.category_id)
				}
			},
			/**
			 * 获取分组列表
			 */
			async getCategory() {
				let res = await getCategory({
					page: 1,
					limit: 5000
				});
				res.data.list.map((item) => {
					if (item.status == 1) {
						item.status = false;
					} else {
						item.status = true;
					}
				});
				this.options = res.data.list;
			},
			async addArticle() {
				await add(this.article);
				this.$message.success('发布成功');
				this.$router.push({ path:'./index'})
			},
			/**
			 * 	文件上传成功时的钩子
			 * @param {Object} res
			 * @param {Object} file
			 */
			handleAvatarSuccess(res, file) {
				console.log(file);
				//this.article.cover = URL.createObjectURL(file.raw);
				this.article.cover = res.data.all;
				this.article.cover_cdn = res.data.cdn;
				this.$refs.upload.clearFiles(); //上传成功之后清除历史记录
			},
			/**
			 * 上传文件之前的钩子
			 * @param {Object} file
			 */
			beforeAvatarUpload(file) {
				console.log('开始上传')
				const arr = [
					'image/jpeg',
					'image/png',
					'image/gif',
				]
				const res = arr.indexOf(file.type);
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (res <= -1) {
					this.$message.error('上传头像图片格式不正确');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return res && isLt2M;
			}
		}
	}
</script>
<style lang="less">
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 100px;
		height: 100px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		text-align: center;
	}
</style>
